import color from "../../constants/color";
 
const styles = {
  pageWrap: {
    minHeight: "100vh",
    backgroundColor: color.lightGray,
    px: { xs: 2, md: 3 },
    py: { xs: 3, md: 5 },
    boxSizing: "border-box",
  },
  pageContainer: {
    maxWidth: "1260px",
    mx: "auto",
    width: "100%",
  },
  headerWrap: {
    mb: 2.5,
  },
  pageTitle: {
    fontSize: { xs: "26px", md: "30px" },
    fontWeight: 700,
    color: color.text,
    lineHeight: 1.15,
  },
  pageSubTitle: {
    mt: 0.6,
    fontSize: "14px",
    fontWeight: 400,
    color: color.lightText,
    lineHeight: 1.45,
  },
  stateText: {
    fontSize: "15px",
    color: color.lightText,
    fontWeight: 500,
    mt: 2,
  },
  planCard: {
    backgroundColor: color.card,
    border: "1px solid #E3E7EC",
    borderRadius: "20px",
    p: { xs: 2, md: 2.5 },
    minHeight: "100%",
    display: "flex",
    flexDirection: "column",
  },
  popularCard: {
    borderColor: "#CBE9D4",
    boxShadow: "0px 10px 24px rgba(32, 32, 32, 0.06)",
  },
  currentCard: {
    borderColor: color.primary,
    borderWidth: "2px",
    backgroundColor: color.lightGreen,
    boxShadow: "0px 10px 24px rgba(32, 32, 32, 0.08)",
  },
  currentBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 0.35,
    borderRadius: "999px",
    px: 0.8,
    py: 0.3,
    border: `1px solid ${color.primary}`,
    backgroundColor: color.primary,
    flexShrink: 0,
  },
  currentBadgeText: {
    color: color.card,
    fontSize: "11px",
    fontWeight: 600,
    lineHeight: 1,
  },
  cardHeadRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: 1,
  },
  planName: {
    fontSize: "28px",
    fontWeight: 700,
    color: color.text,
    lineHeight: 1.2,
  },
  popularBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 0.35,
    borderRadius: "999px",
    px: 0.8,
    py: 0.3,
    border: "1px solid #B7E5C6",
    backgroundColor: color.lightGreen,
    flexShrink: 0,
  },
  popularIcon: {
    color: color.secondary,
    fontSize: "12px",
  },
  popularText: {
    color: color.primary,
    fontSize: "11px",
    fontWeight: 600,
    lineHeight: 1,
  },
  planDescription: {
    mt: 0.75,
    fontSize: "11px",
    color: color.lightText,
    lineHeight: 1.45,
    minHeight: "34px",
  },
  priceBlock: {
    mt: 2.2,
    mb: 1.6,
  },
  pricePrefix: {
    fontSize: "13px",
    color: color.text,
    lineHeight: 1.2,
    mb: 0.3,
  },
  priceRow: {
    display: "flex",
    alignItems: "flex-end",
    gap: 0.2,
    lineHeight: 1,
  },
  priceSign: {
    fontSize: "34px",
    fontWeight: 700,
    color: color.text,
    lineHeight: 1,
    mb: "2px",
  },
  priceValue: {
    fontSize: "40px",
    fontWeight: 700,
    color: color.text,
    lineHeight: 1,
  },
  billingText: {
    mt: 0.8,
    fontSize: "12px",
    color: color.lightText,
    lineHeight: 1.25,
  },
  actionButton: {
    borderRadius: "40px",
    textTransform: "none",
    fontSize: "15px",
    fontWeight: 500,
    height: "42px",
  },
  currentPlanBtn: {
    borderColor: "#E5E7EB",
    backgroundColor: "#E5E7EB",
    color: "#4B5563",
    pointerEvents: "none",
    borderRadius: "40px",
    fontSize: "15px",
    height: "42px",
    "&:hover": {
      borderColor: "#E5E7EB",
      backgroundColor: "#E5E7EB",
    },
  },
  outlineBtn: {
    borderColor: color.primary,
    color: color.primary,
    backgroundColor: "transparent",
    borderRadius: "40px",
    height: "42px",
    fontSize: "15px",
    "&:hover": {
      borderColor: color.primary,
      backgroundColor: "transparent",
    },
  },
  filledBtn: {
    backgroundColor: color.primary,
    color: color.card,
    "&:hover": {
      backgroundColor: color.primary,
    },
  },
  trialText: {
    mt: 1,
    fontSize: "11px",
    color: color.lightText,
    textAlign: "center",
    mb: 1.4,
  },
  divider: {
    borderColor: "#E3E7EC",
    mb: 1.6,
  },
  featureHeading: {
    fontSize: "24px",
    fontWeight: 700,
    color: color.text,
    lineHeight: 1.1,
  },
  featureInfo: {
    mt: 0.6,
    fontSize: "11px",
    color: color.lightText,
    mb: 1.6,
  },
  featureList: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  featureRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: 0.8,
  },
  featureIcon: {
    color: color.primary,
    fontSize: "18px",
    mt: "1px",
    flexShrink: 0,
  },
  featureText: {
    fontSize: "13px",
    fontWeight: 500,
    color: color.text,
    // lineHeight: 1.3,
  },
};
 
export default styles;
